module.exports = __webpack_public_path__ + "img/ver mapa.af9ade74.svg";